import React from "react";
import { Box, IconButton, Typography } from "@mui/material";
import { Styled } from "./styles";
import useFileViewer from "./context";
import CloseIcon from "@mui/icons-material/Close";
import { i18n } from "@/utils/i18n";

const FileViewer: React.FC = () => {
    const { file, visible, close } = useFileViewer();

    const imageExts = ["png", "jpg", "jpeg", "webp", "gif", "svg", "bmp", "avif", "tif", "tiff"];
    const ext = file?.mimeType?.split("/")[1] || "bin";

    const renderContent = () => {
        if (!file || !ext) return null;

        if (imageExts.includes(ext)) {
            return (
                <Box
                    component="img"
                    src={file.url}
                    alt={file.filename}
                    sx={{
                        maxWidth: "80vw",
                        maxHeight: "80vh",
                        width: "auto",
                        height: "auto",
                        objectFit: "contain",
                        display: "block",
                    }}
                    onError={e => {
                        (e.currentTarget as HTMLImageElement).style.display = "none";
                    }}
                />
            );
        }

        if (ext === "pdf") {
            return (
                <iframe
                    src={file.url}
                    title={file.filename}
                    style={{ width: "80vw", height: "80vh", border: "none" }}
                    loading="lazy"
                />
            );
        }

        return (
            <Typography variant="body2">
                {i18n.t("filePreview", { scope: "messages.error" })}
            </Typography>
        );
    };

    return (
        <Styled.Modal open={visible} onClose={close}>
            <Styled.Container>
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        mb: 1,
                        gap: 1,
                    }}
                >
                    <Typography variant="subtitle2" noWrap>
                        {file?.filename}
                    </Typography>
                    <IconButton size="small" onClick={close} aria-label="Close file preview">
                        <CloseIcon fontSize="small" />
                    </IconButton>
                </Box>
                <Styled.Content>{renderContent()}</Styled.Content>
            </Styled.Container>
        </Styled.Modal>
    );
};

export default FileViewer;
